import { RequestService } from "../../../../common/services/RequestService";
import { CREATE_EXECUTOR, UPLOAD_PHOTO_COMPANY_EXECUTOR } from "../constants";
import { adjustExecutor, adjustExecutorSend } from "./adjustExecutorById";
// todo нужен рефакторинг
export const createExecutorRequest = async (profileId, data) => {
  const sendPhoto = async (executorId, companyPhoto) => {
    let uploadPhoto = companyPhoto;
    const formData = new FormData();
    if (typeof uploadPhoto === "object" && uploadPhoto instanceof File) {
      formData.append(`image_file`, uploadPhoto);
      formData.append(`company_id`, executorId);
    } else {
      uploadPhoto = null;
    }
    if (uploadPhoto) {
      try {
        return await RequestService.post(
          UPLOAD_PHOTO_COMPANY_EXECUTOR,
          formData
        );
      } catch (error) {
        console.log(error);
      }
    }
    return null;
  };
  const response = await RequestService.post(
    CREATE_EXECUTOR.replace("{profile_id}", profileId),
    adjustExecutorSend(profileId, data)
  );
  if (data.companyPhoto) {
    if (response.data && response.data.companyId) {
      const resPhoto = await sendPhoto(
        response.data.companyId,
        data.companyPhoto
      );
      if (resPhoto && resPhoto.data && resPhoto.data.url) {
        response.data.picture = resPhoto.data.url;
      }
    }
  }
  return (
    response.data && {
      ...adjustExecutor(response.data),
      status: response.status
    }
  );
};
